import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6347ab50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time_picker" }

import { computed, withDefaults, ref, watch } from 'vue'
import { getTimeStr, getDateStr, getDateObject, getIsoDateStr } from '@/js/utils/date'

type PropsType = {
  modelValue: string
  maxTime?: string
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TimePicker',
  props: {
    modelValue: null,
    maxTime: { default: '23:59' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): string
  (e: 'change', value: string): string
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string, maxTime: string, disabled: boolean };





const pickerOptions = ref({
  format: 'HH:mm',
  selectableRange: `00:00:00 - ${props.maxTime}:00`,
})

const selectedValue = computed({
  get: () => {
    // el-time-pickerのvalueの形式に合わせてDate型にする
    const dateStr = getDateStr(new Date())
    const date = `${dateStr} ${props.modelValue}:00`
    return getDateObject(getIsoDateStr(date))
  },
  set: (value) => {
    // TimePickerコンポーネントのvalueの形式に合わせてString型にする
    const time = getTimeStr(value)
    emit('update:modelValue', time)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change', time)
  },
})

const maxTime = ref<string>(props.maxTime)

watch(maxTime, () => {
  pickerOptions.value.selectableRange = `00:00:00 - ${props.maxTime}:00`
  // 制限があるのに時間がすぎた場合の変更
  if (props.maxTime !== '23:59' && props.modelValue > getTimeStr(new Date())) {
    emit('update:modelValue', props.maxTime)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change', props.maxTime)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_time_picker = _resolveComponent("el-time-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_time_picker, {
      modelValue: _unref(selectedValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null)),
      format: pickerOptions.value.format,
      "range-separator": pickerOptions.value.selectableRange,
      placeholder: _ctx.$t('time_picker.time'),
      size: "small",
      clearable: false,
      editable: false,
      disabled: __props.disabled
    }, null, 8, ["modelValue", "format", "range-separator", "placeholder", "disabled"])
  ]))
}
}

})